import React from "react";
import moment, { Moment } from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const DATE_FORMAT_UI = "MM/DD/YYYY";

interface DesiredDeliveryDateFieldProps {
  label: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
}

const DesiredDeliveryDateField = ({
  label,
  value,
  onChange,
}: DesiredDeliveryDateFieldProps) => {
  const momentValue = React.useMemo((): Moment | null => {
    if (!value?.trim()) return null;
    const m = moment(value, DATE_FORMAT_UI, true);
    return m.isValid() ? m : null;
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <>
        {label}
        {/*
          Mặc định Touch → MobileDatePicker: field read-only, không có nút lịch cạnh input.
          Luôn dùng DesktopDatePicker để có icon + gõ section MM/DD/YYYY.
        */}
        <DatePicker
          readOnly={false}
          desktopModeMediaQuery="(min-width: 0px)"
          format={DATE_FORMAT_UI}
          value={momentValue}
          name="desired_delivery_date"
          onChange={(newValue: Moment | null) =>
            onChange(
              newValue && newValue.isValid()
                ? newValue.format(DATE_FORMAT_UI)
                : ""
            )
          }
          slots={{ openPickerIcon: CalendarTodayIcon }}
          slotProps={{
            field: {
              fullWidth: true,
              size: "small",
              placeholder: DATE_FORMAT_UI,
              inputProps: {
                "aria-label": "Desired delivery date, format MM/DD/YYYY",
              },
              sx: {
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  minHeight: 48,
                  "& fieldset": { borderColor: "#ccc" },
                  "&:hover fieldset": { borderColor: "#b8b8b8" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#007f18",
                    borderWidth: "1px",
                  },
                },
                "& .MuiOutlinedInput-input": {
                  padding: "12px 14px",
                },
              },
              FormHelperTextProps: {
                sx: {
                  fontSize: 12,
                  lineHeight: 1.3,
                  marginTop: 0.75,
                },
              },
            },
            openPickerButton: {
              sx: { color: "#007f18" },
              "aria-label": "Open calendar to choose delivery date",
            },
            openPickerIcon: { sx: { fontSize: 20 } },
          } as any}
        />
      </>
    </LocalizationProvider>
  );
};

export default DesiredDeliveryDateField;
